import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import { BasicSelect} from 'vue-search-select';
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import Printd from 'printd'
import user_tracker from '../../../../usertracker'
import {
  buildConnectionsSearchPayload,
  CONNECTION_SEARCH_PURPOSE,
  getConnectionsSearchUrl
} from '../../../../utils/connectionsSearchApi.js';
export default {
  name: 'scheduled-list',
  components: {
    BasicSelect,
    Multiselect,
    Paginate,
    VueElementLoading,
    DatePicker
  },
  props: [],
  data() {
    return {
      pageCountrule: 0,
      pageCount: 0,
      pageNo: 0,
      isLoading: false,
      schedulesList: [],
      username: '',
      uasertype: '',
      hubid: '',
      //for filter schedule list
      tripsheetnoflt: '',
      status: 'InProcess',
      vendornameitem: {
        value: '',
        text: ''
      },
      vendorname: '',
      vendornameLoading: '',
      fromdate: '',
      todate: '',
      connectiontype: '',
      VehicleCapacityData: {},
      //for schedule local trip
      LocalTripModal: false,
      tripsheetno: '',
      tripsheetnodate: '',
      routetype: '1',
      routetypeerror: '',
      routelist: [],
      routeitem: {
        value: '',
        text: '',
        actualroute: '',
        isBikerAllowed:''
      },
      route: '',
      RouteError: '',
      RouteLoading: '',
      actualroute: '',
      triptypelist: [{
        value: 'local',
        text: 'Local Vendor Based'
      }, {
        value: 'market',
        text: 'Market Hired'
      }],
      triptypeitem: {
        value: '',
        text: ''
      },
      triptype: '',
      triptypevalue:'',
      localvendorlist: [],
      localvendoritem: {
        value: '',
        text: ''
      },
      localvendor: '',
      LocalVendorLoading: '',
      localvehiclenolist: [],
      localvehiclenoitem: {
        value: '',
        text: ''
      },
      localvehicleno: '',
      LocalVehicleNoLoading: '',
      openkm: '',
      drivername: '',
      drivercontactno: '',
      amount: '',
      reasonlist: [{
        value: 1,
        text: "Extra load"
      }, {
        value: 2,
        text: "Vendor not available"
      }, {
        value: 3,
        text: "Branch vehicle vendor not allocated"
      }],
      reasonitem: {
        value: '',
        text: ''
      },
      reason: '',
      VehicleDetails: [],
      hubdata: '',
      useremail: '',
      VehicleError: '',
      TripConnectionScheduleResult: {},
      scheduleDeatilsList: [],
      cutofflist: [],
      cutoffitem: {
        value: '',
        text: '',
        name: '',
        date:''
      },
      cutoff: '',
      CutoffError: '',
      IsCutOffPresent: false,
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      // for trip Transfer
      triptransfermodal: false,
      triptransferbikernamelist: [],
      triptransferbikernameitem: {
        value: '',
        text: ''
      },
      triptransferbikername: '',
      triptransferbikernameLoading: '',
      triptransferbikernameerr: '',
      triptransferbikervehiclelist: [],
      triptransferbikervehicleitem: {
        //value: '',
        text: '',
        vehicleid: ''
      },
      triptransferbikervehicle: '',
      triptransferbikervehicleLoading: '',
      triptransferbikervehicleerr: '',
      replacementreasonlist: [],
      replacementreasonitem: {
        value: '',
        text: ''
      },
      replacementreason: '',
      replacementreasonLoading: '',
      triptransferreasonerr: '',
      triptransferdata: '',
      //for linehaulbiker
      trip: "networklocal",
      tripErr: "",
      bikervehiclelist: [],
      bikervehicleitem: {
        value: '',
        text: '',
        vehicleid: ''
      },
      bikervehiclenumber: '',
      BikerVehicleNumberLoading: '',
      bikerlist: [],
      bikeritem: {
        value: '',
        text: '',
        mobileno: '',
        vehicleno: ''
      },
      bikername: '',
      BikerNameLoading: '',
      validVehicleNoError: false,
      cutOffSelectedIndex:'',
      latecutoffreasonlist:[],
      latecutoffreasonitem:{
        value:'',
        text:''
      },
      connectionvalue:'',
      latecutoffreason:'',
      LateCutOffReasonLoading:'',
      showLateCutOffReason:false,
      hideUsedCutOff:0,
      cutoffdetails:[],
      connectionID:0,
      stateListData:[],
      vehicletype:'',
      vehicletypeitem: {
        value: '',
        text: ''
      },
      vehicletypelist:[],
      vehicletypeloader:'',
      marketvendorname:'',
      bikertrip:false,
      isBikerFlag:false,
      isBikerTripEnabled:false,
      srListForAllocatedParentCity:[],
      srlistitem: {
				value:'',
				text:'',
        name:''
      },
      
			srId :'',
			srName :'',
      parentcityId:0,
      parentcityName:'',
      hubIdList:[],
      srListForAllocatedParentCity:[],
      srErr:'',
      sr:'',
      vehicleType:'',
      hubIdList : [],
      isVTRAFlag : false,
      isAdhocEnable:false,
      adhocvendorlist: [],
      adhocvendoritem: {
        value: '',
        text: ''
      },
      adhocvendor: '',

    }
  },
  //for RegularPrint
  model: {
    totalVolWt: 0,
    totalPhyWt: 0,
    totalLineHaulBags: 0,
    totalBags: 0,
    totalShipments: 0,
    userData:[]
  },
  computed: {
    //for RegularPrint
    TotalVolWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalVolWt, item) {
        return totalVolWt + parseFloat(item.volumetricweight);
      }, 0);
    },
    TotalPhyWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalPhyWt, item) {
        return totalPhyWt + parseFloat(item.volumetricweight);
      }, 0);
    },
    TotalLineHaulBags: function() {
      return this.lineHaulShipmentObjData.length
    },
    TotalBags: function() {
      return 0;
      // return this.lineHaulShipmentObjData.reduce(function(totalBags, item) {
      // 	return totalBags + parseFloat(item.volumetricweight);
      // }, 0);
    },
    TotalShipments: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalShipments, item) {
        return totalShipments + parseFloat(item.totalshipments);
      }, 0);
    }

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },

    //for RegularPrint
    momentDate: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    },
    momentTime: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getHubDetails(arr) {
      if (arr.length < 1) {
        return '';
      }

      var input = {
        hubids: [arr[(arr.length) - 1].HubID]
      }
      return axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
          'data': input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          return result.data.ResponseData[0].HubName
        }, error => {
          console.error(error)
        })
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userData = userdetail;
    this.uasertype = userdetail[0].utype;
    this.username = userdetail[0].FirstName;
    this.hubid = userdetail[0].HubId;
    this.useremail = userdetail[0].email
    // user_tracker.checkUserIP(userdetail[0], "ScheduledList", this.$route.path);
    this.fromdate = new Date()
    this.todate = new Date()
    this.getHubDetails();
    this.getScheduledList();
    if(this.trip!=''){
      this.getConnections(4);
    }
    this.stateListData = window.localStorage.getItem('stateCodeList') ? window.localStorage.getItem('stateCodeList') : [];
  },
  methods: {
    getHubDetails() {
      this.input = {
        hubids: this.hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubdata = result.data.ResponseData[0];
            this.parentcityId = this.hubdata.ParentCityID;
            this.parentcityName = this.hubdata.ParentCityName;
          } else {
            this.hubcode = '';
          }
        }, error => {
          console.error(error)
        })
    },


    selectSr(srListitem) {
			this.srlistitem = srListitem;
			this.srId = this.srlistitem.value;
			this.srName = this.srlistitem.name;
    
		},


    getHubsAgainstParentCity(){
      this.input = {
        ParentCityID: [this.parentcityId]
      }
      this.hubIdList= []
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getSVCMappedAgainstParentCity_master', 
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            const hubdata = result.data.ResponseData.svcData;
            
            hubdata.forEach(element => {
              this.hubIdList.push(element.HubID);
            });
           
            
            this.getSRListAgainstSVCs();

          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })

    },


    getSRListAgainstSVCs(){
      this.input = {
        userType: "3",
        hubids:this.hubIdList
      }

      this.srListForAllocatedParentCity =[]

      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'getSRListAgainstSVCs',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          const srData = result.data.ResponseData.srDetails;
            
          for (let i = 0 ; i < srData.length ; i++){
            this.srListForAllocatedParentCity.push({
              value: srData[i].OldDeliveryUserOrUserId,
              text :srData[i].FirstName + srData[i].LastName +' (' + srData[i].OldDeliveryUserOrUserId+ ')',
              name: srData[i].FirstName + srData[i].LastName
            });
            
            }

          

        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }

      }, error => {
        console.error(error)
      })


    },

    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    editTrip(data) {
      if(data.isbikertrip){
        this.vehicleType ='Biker';

      }
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getVehicleCapacityforSchedule?ConnectionScheduleMasterId=' + data.connectionschedulemasterid + '&TripID=' + data.tripid + '&CurrentHubId=' + data.currenthubid+ '&vehicleType=' + this.vehicleType,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var VehicleCapacityData = result.data.ResponseData
            let routeData = this.$router.push({
              path: "GenerateTripSheet",
              query: {
                scheduleData: data,
                VehicleCapacityData: VehicleCapacityData
              }
            })
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })

    },

    editLspTrip(data) {
     
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchLSPVehicleDetails?lsptripmasterid=' + data.lsptripmasterid + '&lsptripid=' + data.lsptripid + '&currentHubId=' + data.currenthubid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var VehicleCapacityData = result.data.ResponseData
            let routeData = this.$router.push({
              path: "GenerateTripSheet",
              query: {
                scheduleData: data,
                VehicleCapacityData: VehicleCapacityData
              }
            })
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })

    },
    //for filter schedule list
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD HH:MM:SS');
    },
    getScheduledList() {
      this.isLoading = true;
      this.input = ({
        "hubId": this.hubid[0]
      })
      if (this.fromdate != "" && this.fromdate != null) {
        this.input.fromDate = moment(this.fromdate).format('YYYY-MM-DD');
      }
      if (this.todate != "" && this.todate != null) {
        this.input.toDate = moment(this.todate).add(1, 'days').format('YYYY-MM-DD');
      }
      if (this.vendornameitem.value != "" && this.vendornameitem.value != null) {
        this.input.vendorId = this.vendornameitem.value;
      }
      if (this.tripsheetnoflt != "" && this.tripsheetnoflt != null) {
        this.input.tripSheetNo = this.tripsheetnoflt;
      }
      if (this.status != "" && this.status != null) {
        this.input.status = this.status;
      }
      if (this.connectiontype != "" && this.connectiontype != null) {
        this.input.connectionType = parseInt(this.connectiontype);
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'scheduleTripsList',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false;
            this.invalidTokenModal = false
            this.schedulesList = result.data.ResponseData;
            // }
          } else if (result.data.ResultCode == 401) {
            this.isLoading = false;
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.isLoading = false
            this.schedulesList = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },

    getLSPScheduledList() {
      this.isLoading = true;
     
      if (this.fromdate != "" && this.fromdate != null) {
        this.fromDate = moment(this.fromdate).format('YYYY-MM-DD');
      }
      if (this.todate != "" && this.todate != null) {
        this.toDate = moment(this.todate).add(1, 'days').format('YYYY-MM-DD');
      }
      if (this.vendornameitem.value != "" && this.vendornameitem.value != null) {
        this.input.vendorId = this.vendornameitem.value;
      }
      if (this.tripsheetnoflt != "" && this.tripsheetnoflt != null) {
        this.tripSheetNo = this.tripsheetnoflt;
      }
      if (this.status != "" && this.status != null) {
        this.input.status = this.status;
      }
      if (this.connectiontype != "" && this.connectiontype != null) {
        this.connectionType = parseInt(this.connectiontype) == 2 ?'External Partner':'';
      }
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchScheduledTripListForLSP?tripReferenceNumber=' + this.tripSheetNo + '&currentHubId=' + this.hubid[0]+ '&fromDate=' + this.fromDate + '&toDate=' + this.toDate + '&connectionType=' + this.connectionType,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false;
            this.invalidTokenModal = false
            this.schedulesList = result.data.ResponseData;
        
          } else if (result.data.ResultCode == 401) {
            this.isLoading = false;
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.isLoading = false
            this.schedulesList = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    selectedVendor(vendornameitem) {
      this.vendornameitem = vendornameitem
      this.vendorname = vendornameitem.text
    },
    resetflt() {
      this.schedulesList = []
      this.vendornameitem = {
        value: '',
        text: ''
      }
      this.vendorname = ''
      this.vendornameLoading = ''
      this.fromdate = ''
      this.todate = ''
      this.tripsheetnoflt = ''
      this.status = ''
      this.connectiontype = ''
      this.isLoading = false
      this.$validator.reset()
      this.cutoffdetails = []
    },
    onSubmitflt: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          if(this.connectiontype == 2){
            this.getLSPScheduledList();
          }else{
          this.getScheduledList();
          }
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    printManifestData(tripid, currenthubid, connectionschedulemasterid, connectionid) {
      let path = this.$router.resolve("/TripSheetPrint/" + tripid.trim() + "/" + currenthubid + "/" + connectionschedulemasterid + "/" + connectionid)
      window.open(path.href, '_blank');
    },
    //for schedule local trip
    openLocalTripModal() {
      var date = new Date()
      this.tripsheetnodate = moment(date).format('YYYY-MM-DD')
      this.LocalTripModal = true
    },

    getUsedCutOffList() {
      this.hideUsedCutOff=1;
      this.cutoffdetails = []
      if(!this.connectionID || !this.triptypevalue){
       return false
      }
      this.isLoading = true;
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getUsedCutoffDetails?connectionId=' + this.connectionID + '&tripType=' + this.triptypevalue,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {

            this.cutoffdetails = result.data.ResponseData;
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },

    enabledBikerCondtion(){

      if(this.bikertrip){
        this.isBikerTripEnabled = true;
        this.getHubsAgainstParentCity();
        if(this.isBikerTripEnabled){
            this.vehicleType ='Biker';
            
        }
      }else{
        this.isBikerTripEnabled = false;
      }

      this.triptypeitem = {
        value: '',
        text: ''
      };
      this.triptype = '';
      this.localvendoritem = {
        value: '',
        text: ''
      }
      this.localvendor = ''
      this.LocalVendorLoading = ''
      this.cutofflist = []
      this.cutoffitem = {
        value: '',
        text: '',
        name: '',
        date:''
      }
      this.cutoff = ''
      this.CutoffError = ''
      this.IsCutOffPresent = false
      this.$validator.reset()
      if(this.isBikerTripEnabled){
        this.getCutOffList()
        }
      


    },


    closeLocalTripModal() {
      this.LocalTripModal = false,
      this.vehicletypelist = [],
      this.vehicletypeitem = {
        value: '',
        text: ''
      },
      this.marketvendorname = '';
    },
    onSubmitLocalTrip: function(localtripTab) {
      this.hideUsedCutOff=0

      this.$validator.validateAll('localtripTab').then((result) => {
        if (!result) {
          // if (this.routetype == '') {
          //   this.routetypeerror = 'Select Route Type'
          // } else {
          //   this.routetypeerror = ''
          // }
           return false;
        } else {
          let vehiclenoarr = this.localvehicleno.trim().match(/.{0,2}/g);
          if (this.stateListData.length > 0 && !this.stateListData.includes(vehiclenoarr[0].toUpperCase())){
            this.$alertify.error('Error: Invaild Vehicle Number');
            return false;
          }
          if(this.isBikerTripEnabled){
            this.generateplacementIDforBiker();

          }else{
          this.GeneratePlacementID();
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getConnections(value) {
      this.connectionvalue=value
      if (value == 6) {
        this.getBikerVehicleNumerList()
      }
      this.RouteLoading = 'Loading Route Name...'
      var connectionData = []
      this.isVTRAFlag = false
      this.routelist = []
      this.input = buildConnectionsSearchPayload(CONNECTION_SEARCH_PURPOSE.LOCAL_TP, {
        type: value,
        source: this.hubid[0]
      })
      axios({
          method: 'POST',
          url: getConnectionsSearchUrl(),
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.RouteLoading = ''
          if (result.data.ResultCode == 100) {
            connectionData = result.data.ResponseData
            this.isVTRAFlag = result.data.isVTRAFlag
            this.isAdhocEnable = result.data.IsAdhocEnable
            this.invalidTokenModal = false
            if (connectionData.length > 0) {
              this.RouteError = ''
              for (var i = 0; i < connectionData.length; i++) {
                this.routelist.push({
                  value: connectionData[i].ConnectionID,
                  text1: connectionData[i].ConnectionName,
                  text: connectionData[i].FullConnectionName,
                  actualroute: connectionData[i].FullConnectionName,
                  isBikerAllowed:connectionData[i].IsBikerAllowed
                })
              }
            } else {
              this.RouteError = "No Connection found"
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.RouteLoading = ''
          console.error(error)
        })
    },
    selectRoute(routeitem) {
      this.ResetLocalTripDetails();
      this.connectionID = routeitem.value
      this.routeitem = routeitem
      this.route = this.routeitem.text1
      this.actualroute = routeitem.actualroute;
      this.isBikerFlag = routeitem.isBikerAllowed;
      this.cutofflist = []
      this.cutoffitem = {
        value: '',
        text: '',
        name: '',
        date:''
      }
      this.cutoff = ''
      this.CutoffError = ''
      this.IsCutOffPresent = false
      this.cutOffSelectedIndex=''
      this.latecutoffreasonlist=[]
      this.latecutoffreasonitem={
        value:'',
        text:''
      },
      this.latecutoffreason='',
      this.LateCutOffReasonLoading='',
      this.showLateCutOffReason=false
      if (this.routeitem.value != '' && this.triptypeitem.value!='') {
        // if (this.triptypeitem.value != 'market') {
          this.cutofflist = []
          this.cutoffitem = {
            value: '',
            text: '',
            name: '',
            date:''
          }
          this.cutoff = ''
          this.CutoffError = ''
          this.IsCutOffPresent = false
          this.$validator.reset()
          this.getCutOffList()
        // }
        //  else {
        //   this.cutoffitem = {
        //     value: null,
        //     text: 'Unscheduled',
        //     name: 'Unscheduled',
        //     date:'Unscheduled'
        //   }
        //   this.cutoff = 'Unscheduled'
        //   this.CutoffError = ''
        //   this.IsCutOffPresent = false
        //   this.cutofflist = [{
        //     value: null,
        //     text: "Unscheduled",
        //     name: "Unscheduled",
        //     date:"Unscheduled"
        //   }]
        //   this.$validator.reset()
        // }
      }
      this.hideUsedCutOff=0;
    },
    selectTripType(triptypeitem) {
      this.triptypeitem = triptypeitem
      this.triptype = triptypeitem.text
      this.triptypevalue=triptypeitem.value;
      this.localvendoritem = {
        value: '',
        text: ''
      }
      this.localvendorlist = []
      this.localvendor = ''
      this.localvehiclenoitem = {
        value: '',
        text: '',
        isGPS: '',
        GPScompany: ''
      }
      this.localvehicleno = ''
      this.localvehiclenolist = []
      this.$validator.reset()
      this.getLocalVendorList()
      if (this.localvendor != '' && this.triptype != '') {
        this.getLocalVehicleNo()
      }
      if(this.triptypevalue==='local')
        this.triptypevalue='regular';
      if(this.triptypevalue==='market')
      {
        this.cutOffSelectedIndex=''
        this.latecutoffreasonlist=[]
        this.latecutoffreasonitem={
          value:'',
          text:''
        },
        this.latecutoffreason='',
        this.LateCutOffReasonLoading='',
        this.showLateCutOffReason=false
      }
      if (this.routeitem.value != '') {
        // if( this.triptypeitem.value!='market'){
          this.cutofflist = []
          this.cutoffitem = {
            value: '',
            text: '',
            name: '',
            date:''
          }
          this.cutoff = ''
          this.CutoffError = ''
          this.IsCutOffPresent = false
          
          // bug-7263 : Blocker: Not showing any cut off for the connection, while scheduling.
          if (
            this.triptypeitem.value == 'market' ||
            (this.triptypeitem.value == 'local' && !this.isVTRAFlag)
          ) {
            this.getCutOffList();
          }
        // }
        // else {
        //   this.cutoffitem = {
        //     value: null,
        //     text: 'Unscheduled',
        //     name: 'Unscheduled',
        //     date:"Unscheduled"
        //   }
        //   this.cutoff = 'Unscheduled'
        //   this.CutoffError = ''
        //   this.IsCutOffPresent = false
        //   this.cutofflist = [{
        //     value: null,
        //     text: "Unscheduled",
        //     name: "Unscheduled",
        //     date:"Unscheduled"
        //   }]
        // }
      }
      this.hideUsedCutOff=0;
      this.vehicletypeloader = '';
      this.vehicletypelist = []
      this.vehicletypeitem = {
        value: '',
        text: ''
      }
      this.marketvendorname = '';
      if(this.triptypeitem.value == "market"){
      if (!this.isAdhocEnable) {
       this.getVehicleTypeforMarket();
     } else {
       this.getAdhocVendorList();
     }
      }
    },
    getLocalVendorList() {
      this.LocalVendorLoading = 'Loading Vendor Name...'
      var VendorNameData = []
      this.localvendorlist = []
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag){
        this.input = {
          HubId: this.hubid[0],
          VendorType: this.triptypeitem.value,
          connectionId:this.connectionID
        }    
        }else {
        this.input = {
          HubId: this.hubid[0],
          VendorType: this.triptypeitem.value,
        }
      }
      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'getvendorlistforlocalplacement',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
        .then(result => {
          this.LocalVendorLoading = ''
          if (result.data.ResultCode == 100) {
            var VendorNameData = result.data.ResponseData;
            for (var i = 0; i < VendorNameData.length; i++) {
              this.localvendorlist.push({
                value: VendorNameData[i].VehicleVendorCompanyID,
                text: VendorNameData[i].VehicleVendorCompanyName,
                email: VendorNameData[i].VehicleVendorEmailId
              })
            }
            if(this.triptypeitem.value == 'market'){
              this.localvendoritem.value = this.localvendorlist[0].value;
              this.localvendor = this.localvendorlist[0].text;
              this.localvendoritem.text = this.localvendor;
            }
          } else {
            VendorNameData = []
            this.localvendorlist = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.LocalVendorLoading = ''
          console.error(error)
        })
    },

    generateplacementIDforBiker(){
      if (this.isBikerTripEnabled) {
        var re = /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/;
        if (re.test(this.localvehicleno) == false) {
          this.isLoading = false;
          this.validVehicleNoError = true;
          return false;
        } else {
          this.validVehicleNoError = false;
        }
      }
      this.isLoading = true;
      var date = new Date()
      var placementdate = moment(date).format('YYYY-MM-DD')
      if(this.isBikerTripEnabled){
        this.input = {
            "hubid": this.hubid[0],
            "hubname":this.hubdata.HubName,
            "hubaddress": this.hubdata.HubAddress,
            "vehicleplacementdate": placementdate,
            "connectionid": this.routeitem.value,
            "connectionname": this.routeitem.text1,
            "drivername":this.srName,
            "srusername":this.srName,
            "sruserid": this.srId,
            "vehiclenumber": this.localvehicleno,
            "type": "biker",
            "cutoffid" :this.cutoffitem.value,
            "cutoffdate":this.cutoffitem.date ,
            "cutoffname":this.cutoffitem.name,
            "triptype":"network-local",
            "status":"placed",
            "createdby":this.useremail
        }
        axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'saveBikerPlacementVehicle_tms',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.localplacementid = result.data.ResponseData.placementid
            this.scheduleLocalBikerTrip()
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    }
    
  },
    selectVendor(localvendoritem) {
      this.localvendoritem = localvendoritem
      this.localvendor = localvendoritem.text
      this.localvehiclenoitem = {
        value: '',
        text: '',
        isGPS: '',
        GPScompany: ''
      }
      this.localvehicleno = ''
      this.VehicleError = ''
      this.localvehiclenolist = []
      this.$validator.reset()
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == "local" && this.isVTRAFlag) {
        this.vehicletypelist = [],
        this.vehicletypeitem = {
          value: '',
          text: ''
        },
        this.cutofflist = []
        this.cutoffitem = {
        value: '',
        text: '',
        name: '',
        date:''
      }
      this.cutoff = ''
      this.CutoffError = '';
        this.getVehicleTypeforMarket()
      } else{
        if (this.localvendor != '' && this.triptype != '') {
          this.getLocalVehicleNo()
        }
      }

    },
    getLocalVehicleNo() {
      if(!this.localvendoritem.value){
        return false
      }
      this.LocalVehicleNoLoading = 'Loading Vehicle Number...'
      var VehicleNoData = []
      this.localvehiclenolist = []
      this.VehicleError = ''
      this.input = {
        hubid: this.hubid[0],
        vehiclevendorcompanyid: this.localvendoritem.value,
        vendortype: this.triptypeitem.value
      };
      
      if ( this.triptypeitem.value == 'local'&& this.isVTRAFlag) {
        this.input.connectionid  = this.connectionID;
        this.input.vehicletypeid = this.VehicleId;
      }

      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'localvehiclenumberlist',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
        .then(result => {
          this.LocalVehicleNoLoading = ''
          if (result.data.ResultCode == 100) {
            var VehicleNoData = result.data.ResponseData;
            this.VehicleError = ''
            var localvehiclenolist = []
            for (var i = 0; i < VehicleNoData.length; i++) {
              localvehiclenolist.push({
                text: VehicleNoData[i].VehicleNumber,
                isGPS: VehicleNoData[i].IsGPSEnabled,
                GPScompany: VehicleNoData[i].GPSCompanyName,
                vehiclevendorid: VehicleNoData[i].VehicleVendorId,
                vehicletype: VehicleNoData[i].VehicleType
              })
            }
            this.localvehiclenolist = localvehiclenolist.reduce((unique, o) => {
              if (!unique.some(obj => obj.text === o.text)) {
                unique.push(o);
              }
              return unique;
            }, [])
          } else {
            VehicleNoData = []
            this.localvehiclenolist = []
            this.VehicleError = result.data.ReturnMessage
          }
        }, error => {
          this.LocalVehicleNoLoading = ''
          this.$alertify.error("Vehicle API Error")
          console.error(error)
        })
    },
    selectVehicleNo(localvehiclenoitem) {
      this.localvehiclenoitem = localvehiclenoitem
      this.localvehicleno = localvehiclenoitem.text

      // Adhoc Vehicle
      if(this.triptypeitem.value == 'market' && this.isAdhocEnable){
        this.vehicletypelist = [];
        this.vehicletypeitem = {};
        this.vehicletype = '';
        if (localvehiclenoitem.value) {
          this.vehicletypeitem = {
            value: localvehiclenoitem.raw.VehicleTypeId,
            text: localvehiclenoitem.raw.VehicleTypeName
          }
          this.vehicletype=localvehiclenoitem.raw.VehicleTypeName
          this.localvendoritem = {
              value: localvehiclenoitem.raw.VehicleVendorId,
              text: localvehiclenoitem.raw.VendorName
             };   
        }else{
          return;
        }
      }

      this.getVehicleDetails()
    },
    getVehicleDetails() {
      var VendorNameData = []
      this.VehicleDetails = []
      if (this.trip == 'linehaulbiker') {
        this.input = {
          vehicleid: this.bikervehicleitem.vehicleid,
        }
      } 
       // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag){
        this.input = {
          vehicleid: this.localvehiclenoitem.vehicletype[0],
          vendorid: this.localvendoritem.value,
          connectionid:this.connectionID
        }    
        }else {
         if(this.triptypeitem.value == 'market' && this.isAdhocEnable){
             this.input = {
          vehicleid: this.localvehiclenoitem.raw.VehicleTypeId,
        }
          }
         else  {this.input = {
          vehicleid: this.localvehiclenoitem.vehicletype[0],
        }}
      }
      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'getVehicleDetails',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.VehicleDetails = result.data.ResponseData;
          } else {
            this.VehicleDetails = []
          }
        }, error => {
          console.error(error)
        })
    },
    selectReason(reasonitem) {
      this.reasonitem = reasonitem
      this.reason = reasonitem.text
    },
    GeneratePlacementID() {
      this.isLoading = true;
      var date = new Date()
      var placementdate = moment(date).format('YYYY-MM-DD')
      if (this.trip == 'linehaulbiker') {
        this.input = {
          "vehiclevendorcompanyid": this.bikeritem.value,
          "vendorname": this.bikeritem.text,
          "vehiclevendoremail": this.useremail,
          "hubid": this.hubid[0],
          "hubname": this.hubdata.HubName,
          "hubaddress": this.hubdata.HubAddress,
          "vehicleplacementdate": placementdate,
          "connectionid": this.routeitem.value,
          "connectionname": this.routeitem.text1,
          "vehiclename": this.VehicleDetails[0].VehicleName,
          "vehicleid": this.VehicleDetails[0].VehicleId,
          "vehiclenumber": this.bikervehicleitem.value,
          "drivername": this.bikeritem.text,
          "phonenumber": this.bikeritem.mobileno,
          "status": "placed",
          "type": 'linehaulbiker',
          "isgpsenabled": 0,
          "gpscompanyname": '',
          "vehiclevendorid": 0
        }
      } else {
         let isgpsenabled =this.localvehiclenoitem && this.localvehiclenoitem.isGPS  ? this.localvehiclenoitem.isGPS : 0
         let  gpscompanyname = this.localvehiclenoitem && this.localvehiclenoitem.GPScompany ? this.localvehiclenoitem.GPScompany: ''
         let  vehiclevenderid =this.localvehiclenoitem && this.localvehiclenoitem.vehiclevendorid != null ? this.localvehiclenoitem.vehiclevendorid: 0
        if (this.triptypeitem.value == 'market') {
          var re = /^([A-Z|a-z]{2}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{3})?([A-Z|a-z]{2}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1}\s{1}\d{3,4})?$/;
          if (re.test(this.localvehicleno) == false) {
            this.isLoading = false;
            this.validVehicleNoError = true;
            return false;
          } else {
            this.validVehicleNoError = false;
          }
          // var VehicleName = "32 FT Single Axel (9-MT)"
          // var VehicleId = 37
          var VehicleName = this.VehicleName
          var VehicleId = this.VehicleId
          //VehicleDetails according to featureflag
          if(this.isAdhocEnable){
          var VehicleName = this.VehicleDetails[0].VehicleName
          var VehicleId = this.VehicleDetails[0].VehicleId
          isgpsenabled = this.localvehiclenoitem.raw && this.localvehiclenoitem.raw.IsGPSEnabled ? this.localvehiclenoitem.raw.IsGPSEnabled : 0
          gpscompanyname= this.localvehiclenoitem.raw &&this.localvehiclenoitem.raw.GPSCompanyName? this.localvehiclenoitem.raw.GPSCompanyName: ''
          vehiclevenderid = this.localvehiclenoitem.raw && this.localvehiclenoitem.raw.VehicleVendorId != null? this.localvehiclenoitem.raw.VehicleVendorId: 0

          }
        } else {
          var VehicleName = this.VehicleDetails[0].VehicleName
          var VehicleId = this.VehicleDetails[0].VehicleId
        }
        this.input = {
          "vehiclevendorcompanyid": this.localvendoritem.value,
          "vendorname": this.localvendoritem.text,
          "vehiclevendoremail": this.useremail,
          "hubid": this.hubid[0],
          "hubname": this.hubdata.HubName,
          "hubaddress": this.hubdata.HubAddress,
          "vehicleplacementdate": placementdate,
          "connectionid": this.routeitem.value,
          "connectionname": this.routeitem.text1,
          "vehiclename": VehicleName,
          "vehicleid": VehicleId,
          "vehiclenumber": this.localvehicleno,
          "drivername": this.drivername,
          "phonenumber": this.drivercontactno,
          "status": "placed",
          "type": this.triptypevalue,
         "isgpsenabled": isgpsenabled,
          "gpscompanyname": gpscompanyname,
          "vehiclevendorid": vehiclevenderid,
          "cutoffid" : this.cutoffitem.value,
          "cutoffdate" : this.cutoffitem.date,
          "cutoffname" : this.cutoffitem.name,
          "latecutoffreason":this.showLateCutOffReason===true?this.latecutoffreasonitem.text: '',
          "marketvendorname":this.marketvendorname,
          "triptype":'network-local'
        };
      }

      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'savelocalplacementdetails',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.localplacementid = result.data.ResponseData.placementid
            this.scheduleLocalBikerTrip()
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    scheduleLocalBikerTrip() {
      this.input =({
        "currentHubId": this.hubid[0],
        "placementId": this.localplacementid,
        "connectionName": this.routeitem.text1,
        "fullConnectionName": this.actualroute,
        "connectionId": this.routeitem.value,
        "hubCode": this.hubdata.HubCode,
        "hubName": this.hubdata.HubName,
        "createdBy": this.useremail

    })
    if (this.trip == 'linehaulbiker') {
      Object.assign(this.input,{
        
        "vehicleNo": this.bikervehicleitem.value,
        "vendorId": this.bikeritem.value,
        "vendorName": this.bikeritem.text,
        "driverDetails": [{
          "DriverName": this.bikeritem.text,
          "Mobile": this.bikeritem.mobileno
        }],
        "vendorType": "biker",
        "connectionType": 6,
        "isBikerTrip": false
      })
    } else {
      if(this.isBikerTripEnabled){
        Object.assign( this.input ,{
       
       "vehicleNo": this.localvehicleno,
       "vendorId": this.srId,
       "vendorName": null,
       "driverDetails": [{
         "Mobile": null,
         "DriverName":this.srName
       }],
       "vendorType": null,
       "connectionType": 4,
       "scheduleCutOff": this.cutoffitem.text,
       "scheduleCutOffId": this.cutoffitem.value,
       "isCutOffPresent": this.IsCutOffPresent,
       "CutOffDate":this.cutoffitem.date,
       "isBikerTrip": true
     })
    }else{
      Object.assign(this.input, {
        "vehicleNo": this.localvehicleno,
        "vendorId": this.localvendoritem.value,
        "vendorName": this.localvendoritem.text,
        "driverDetails": [{
          "DriverName": this.drivername,
          "Mobile": this.drivercontactno
        }],
        "vendorType": this.triptypeitem.value,
        "connectionType": 4,
        "scheduleCutOff": this.cutoffitem.text,
        "scheduleCutOffId": this.cutoffitem.value,
        "isCutOffPresent": this.IsCutOffPresent,
        "CutOffDate":this.cutoffitem.date,
        "isBikerTrip": false
      })

    }
     
    }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'tripConnectionScheduleMaster',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.TripConnectionScheduleResult = result.data.ResponseData
            if (this.trip == 'linehaulbiker') {
              this.scheduleDeatilsList.push({
                "thcno": result.data.ResponseData.TripID,
                "tripid": result.data.ResponseData.TripID,
                "connectionschedulemasterid": result.data.ResponseData.ConnectionScheduleMasterId,
                "fullconnectionname": this.routeitem.text1,
                "vehicleno": this.bikervehicleitem.value,
                "vehiclename": this.VehicleDetails[0].VehicleName,
                "vendorname": this.bikeritem.text,
                "invoiceno": result.data.ResponseData.InvoiceNo,
                "vendorid": this.bikeritem.value,
                "connectionid": this.routeitem.value,
                "routemode": "Surface",
                "triptype": "linehaulbiker"
              })
            } else if(this.isBikerTripEnabled){
              this.scheduleDeatilsList.push({
              "thcno": result.data.ResponseData.TripID,
              "tripid": result.data.ResponseData.TripID,
              "connectionschedulemasterid": result.data.ResponseData.ConnectionScheduleMasterId,
              "fullconnectionname": this.routeitem.actualroute,
              "vehicleno": this.localvehicleno,
              "vehiclename": "Biker",
              "vendorname": "",
              "invoiceno": result.data.ResponseData.InvoiceNo,
              "vendorid": this.srId,
              "connectionid": this.routeitem.value,
              "routemode": "Surface",
              "triptype": "network-local",
              "isbikertrip":true
         })
            }else {
              if (this.triptypeitem.value == 'market') {
                var VehicleName = this.VehicleName
                 if(this.isAdhocEnable){
                var VehicleName = this.vehicletype
                }
              } else {
                var VehicleName = this.VehicleDetails[0].VehicleName
              }
              this.scheduleDeatilsList.push({
                "thcno": result.data.ResponseData.TripID,
                "tripid": result.data.ResponseData.TripID,
                "connectionschedulemasterid": result.data.ResponseData.ConnectionScheduleMasterId,
                "fullconnectionname": this.routeitem.actualroute,
                "vehicleno": this.localvehicleno,
                "vehiclename": VehicleName,
                "vendorname": this.localvendoritem.text,
                "invoiceno": result.data.ResponseData.InvoiceNo,
                "vendorid": this.localvendoritem.value,
                "connectionid": this.routeitem.value,
                "routemode": "Surface",
                "triptype": "network-local"
              })
            }
            this.$alertify.success(result.data.ReturnMessage);
            this.goToGenerateTripSheetPage()
            this.LocalTripModal = false
            this.ResetLocalTripDetails()
            this.ResetBikerTripDetails()
            this.trip = ''
            this.tripErr = ''
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
          user_tracker.checkUserIP(this.userData[0], "ScheduleLocal-TP or linehaulbiker Trip", this.$route.path,this.input)
        }, error => {
          console.error(error)
        })
    },
    goToGenerateTripSheetPage() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getVehicleCapacityforSchedule?ConnectionScheduleMasterId=' + this.TripConnectionScheduleResult.ConnectionScheduleMasterId + '&TripID=' + this.TripConnectionScheduleResult.TripID + '&CurrentHubId=' + this.hubid[0] + '&vehicleType=' + this.vehicleType,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var VehicleCapacityData = result.data.ResponseData
            let routeData = this.$router.push({
              path: "GenerateTripSheet",
              query: {
                scheduleData: this.scheduleDeatilsList[0],
                VehicleCapacityData: VehicleCapacityData
              }
            })
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    getCutOffList() {
      var cutofflist = []
      // Hub: 7244: VTRA
      this.cutofflist = []
      this.cutoffitem = {
        value: '',
        text: '',
        name: '',
        date:''
      }
      this.cutoff = ''
      this.CutoffError = '';
    
      this.input = {
        "connectionId": parseInt(this.routeitem.value),
        "hubId": this.hubid[0],
        "connectionType": parseInt(this.connectionvalue),
      }
      if (this.triptypeitem.value == 'local'&& this.isVTRAFlag){
        this.input.vendorid = this.localvendoritem.value;
        this.input.vehicletypeid = this.VehicleId;
      }
      if(this.isBikerTripEnabled){
        this.input.tripType = "biker";
      }else{
        this.input.tripType = this.triptypevalue;
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getCutOff",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CutoffError = ''
            cutofflist = result.data.ResponseData;
            this.IsCutOffPresent = result.data.IsCutOffPresent
            for (var i = 0; i < cutofflist.length; i++) {
              this.cutofflist.push({
                value: cutofflist[i].CutoffID,
                text: cutofflist[i].CutoffDateTime,
                name: cutofflist[i].CutoffName,
                date:cutofflist[i].CutOffDate
              })
            }
            if (this.cutofflist.length == 1) {
              for (var i = 0; i < this.cutofflist.length; i++) {
                this.cutoffitem = {
                  value: this.cutofflist[i].value,
                  text: this.cutofflist[i].text,
                  name: this.cutofflist[i].name,
                  date:this.cutofflist[i].date
                }
                this.cutoff = this.cutofflist[i].text
              }
            } else {
              this.cutoffitem = {
                value: '',
                text: '',
                name: '',
                date:''
              }
              this.cutoff = ''
            }
          } else {
            this.CutoffError = result.data.ReturnMessage
            this.IsCutOffPresent = false
            cutofflist = []
            //this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    selectedCutoff(cutoffitem) {
      this.cutoffitem = cutoffitem
      this.cutoff = cutoffitem.text
      if(this.triptypeitem.value=='local' && this.IsCutOffPresent!=false && this.cutofflist.length>1)
      {
        for(let i=0;i<this.cutofflist.length;i++)
        {
          if(this.cutofflist[i].value===cutoffitem.value)
            this.cutOffSelectedIndex=i;
        }
      }
      if(this.cutOffSelectedIndex!=0)
      {
        this.cutOffSelectedIndex=''
        this.latecutoffreasonitem={
          value:'',
          text:''
        },
        this.latecutoffreasonlist=[]
        this.latecutoffreason=''
        this.LateCutOffReasonLoading='Loading Late Cut-Off Reasons...'
        this.showLateCutOffReason=true
        let LateCutOffReasonData=[]
        axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getCutOffReasons',
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        }).then(result => {
          this.LateCutOffReasonLoading = ''
          if (result.data.ResultCode == 100) {
            LateCutOffReasonData = result.data.ResponseData;
            for (let i = 0; i < LateCutOffReasonData.length; i++) {
              this.latecutoffreasonlist.push({
                value: LateCutOffReasonData[i].id,
                text: LateCutOffReasonData[i].reason,
              })
            }
            LateCutOffReasonData= []
          } else {
            LateCutOffReasonData= []
            this.latecutoffreasonlist = []
            this.$alertify.error(result.data.ReturnMessage)
          }

        }, error => {
          this.LateCutOffReasonLoading = ''
          console.error(error)
        })
      }
      else
      {
          this.cutOffSelectedIndex=''
          this.latecutoffreasonitem={
            value:'',
            text:''
          },
          this.latecutoffreasonlist=[],
          this.latecutoffreason='',
          this.LateCutOffReasonLoading='',
          this.showLateCutOffReason=false
      }
    },
    selectLateCutOffReason(latecutoffreasonitem)
    {
      this.latecutoffreasonitem=latecutoffreasonitem
      this.latecutoffreason=latecutoffreasonitem.value

    },
    ResetLocalTripDetails() {
      this.hideUsedCutOff=0
      var date = new Date()
      this.tripsheetnodate = moment(date).format('YYYY-MM-DD')
      this.routetype = '1'
      this.routetypeerror = ''
      this.routeitem = {
        value: '',
        text: '',
        actualroute: '',
        isBikerAllowed:''
      }
      this.route = ''
      this.RouteError = ''
      this.RouteLoading = ''
      this.actualroute = ''
      this.triptypeitem = {
        value: '',
        text: ''
      }
      this.triptype = ''
      this.localvendoritem = {
        value: '',
        text: ''
      }
      this.localvendor = ''
      this.LocalVendorLoading = ''
      this.localvehiclenoitem = {
        value: '',
        text: ''
      }
      this.localvehicleno = ''
      this.LocalVehicleNoLoading = ''
      this.openkm = ''
      this.drivername = ''
      this.drivercontactno = ''
      this.amount = ''
      this.reasonitem = {
        value: '',
        text: ''
      }
      this.reason = ''
      this.VehicleError = ''
      this.cutoffitem = {
        value: '',
        text: '',
        name: ''
      }
      this.cutoff = ''
      this.cutofflist = []
      this.CutoffError = ''
      this.IsCutOffPresent = false
      this.cutOffSelectedIndex=''
      this.showLateCutOffReason=false,
      this.latecutoffreasonlist=[]
      this.latecutoffreason=''
      this.LateCutOffReasonLoading=''
      this.latecutoffreasonitem={
        value:'',
        text:'',
      }
      this.$validator.reset()
      this.validVehicleNoError = false;
      this.vehicletype = ''
      this.vehicletypeitem = {
       value: '',
       text: ''
     }
     this.vehicletypeloader = '';
     this.marketvendorname = '';
     this.isBikerTripEnabled = false;
     this.srData =[];
     this.vehicleType ='';
     this.srListForAllocatedParentCity =[];
     this.isBikerFlag=false;
     this.bikertrip =false;
     this.sr= '';
     this.adhocvendorlist=[],
      this.adhocvendoritem= {
        value: '',
        text: ''
      },
      this.adhocvendor= ''

    },
    // for trip transfer
    openTripTransferModal(data) {
      this.triptransfermodal = true
      this.triptransferdata = data
      this.getBikerVehicleNumerList()
    },
    closeTripTransferModal() {
      this.triptransfermodal = false
      //this.bikername =''
      //this.bikernameitem = {value:'',text:''}
    },
    selectedTripTransferBikerVehicle(triptransferbikervehicleitem) {
      this.triptransferbikervehicleitem = triptransferbikervehicleitem
      this.triptransferbikervehicle = triptransferbikervehicleitem.text
      this.getBikerDetails(1)
    },
    selectedTripTransferBiker(triptransferbikernameitem) {
      this.triptransferbikernameitem = triptransferbikernameitem
      this.triptransferbikername = triptransferbikernameitem.text
    },
    selectedReplacementReason(replacementreasonitem) {
      this.replacementreasonitem = replacementreasonitem
      this.replacementreason = replacementreasonitem.text
    },
    transferTrip() {
      if (this.triptransferbikervehicle == '') {
        this.triptransferbikervehicleerr = 'Select Vehicle Number'
        return false;
      } else {
        this.triptransferbikervehicleerr = ''
      }
      if (this.triptransferbikername == '') {
        this.triptransferbikernameerr = 'Select Biker Name'
        return false;
      } else {
        this.triptransferbikernameerr = ''
      }
      if (this.replacementreason == '') {
        this.triptransferreasonerr = 'Select Reason'
        return false;
      } else {
        this.triptransferreasonerr = ''
      }
      this.input = {
        "oldBikeNumber": this.triptransferdata[0].vehicleno,
        "newBikeNumber": this.triptransferbikervehicle,
        "replacementReason": "Bike Damaged",
        // "replacementReason": this.replacementreason,
        "newBikerID": parseInt(this.triptransferbikernameitem.value),
        "connectionScheduleMasterID": parseInt(this.triptransferdata[0].connectionschedulemasterid),
        //"placementID": parseInt(this.triptransferdata[0].),
        "tripID": parseInt(his.triptransferdata[0].tripid),
        "lastmodifiedby": this.useremail
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'transferLinehaulBikerTrip',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    cancelTransferTrip() {
      this.triptransfermodal = false
      this.triptransferbikernameitem = {
        value: '',
        text: ''
      }
      this.triptransferbikername = ''
      this.triptransferbikernameLoading = ''
      this.triptransferbikernameerr = ''
      this.triptransferbikervehicleitem = {
        //value: '',
        text: '',
        vehicleid: ''
      }
      this.triptransferbikervehicle = ''
      this.triptransferbikervehicleLoading = ''
      this.triptransferbikervehicleerr = ''
      this.replacementreasonitem = {
        value: '',
        text: ''
      }
      this.replacementreason = ''
      this.replacementreasonLoading = ''
      this.triptransferreasonerr = ''
      this.triptransferdata = ''
    },
    // for Linehaul Biker
    getBikerVehicleNumerList() {
      this.BikerVehicleNumberLoading = 'Loading Biker Vehicle Number...'
      var BikerVehicleNumberData = []
      this.bikervehiclelist = []
      this.triptransferbikervehiclelist = []
      this.input = {
        hubId: this.hubid[0],
        vendorType: "biker"
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getLineHaulBikersListByHubId',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.BikerVehicleNumberLoading = ''
          if (result.data.ResultCode == 100) {
            var BikerVehicleNumberData = result.data.ResponseData;
            for (var i = 0; i < BikerVehicleNumberData.length; i++) {
              this.bikervehiclelist.push({
                value: BikerVehicleNumberData[i].VehicleNumber,
                text: BikerVehicleNumberData[i].VehicleNumber,
                vehicleid: BikerVehicleNumberData[i].VehicleType
              })
              this.triptransferbikervehiclelist.push({
                //value: BikerVehicleNumberData[i].VehicleNumber,
                text: BikerVehicleNumberData[i].VehicleNumber,
                vehicleid: BikerVehicleNumberData[i].VehicleType
              })
            }
          } else {
            BikerVehicleNumberData = []
            this.bikervehiclelist = []
            this.triptransferbikervehiclelist = []
            this.$alertify.error(result.data.ReturnMessage)
          }

        }, error => {
          this.BikerVehicleNumberLoading = ''
          console.error(error)
        })
    },
    selectBikerVehicleNumber(bikervehicleitem) {
      this.bikervehicleitem = bikervehicleitem
      this.bikervehiclenumber = bikervehicleitem.text
      this.getBikerDetails()
      this.getVehicleDetails()
    },
    getBikerDetails(istriptransfer) {
      if (istriptransfer == 1) {
        this.bikervehiclenumber = this.triptransferbikervehicle
      }
      this.BikerNameLoading = 'Loading Biker Vehicle Number...';
      var BikerData = []
      this.bikerlist = []
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getLineHaulBikerDetailsByBikeNo?vehicleNo=' + this.bikervehiclenumber,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.BikerNameLoading = ''
          if (result.data.ResultCode == 100) {
            var BikerData = result.data.ResponseData;
            for (var i = 0; i < BikerData.length; i++) {
              this.bikerlist.push({
                value: BikerData[i].BikerVendorId,
                text: BikerData[i].BikerName,
                mobileno: BikerData[i].BikerMobileNo,
                vehicleno: BikerData[i].VehicleNumber,
              })
              this.triptransferbikernamelist.push({
                value: BikerData[i].BikerVendorId,
                text: BikerData[i].BikerName,
                mobileno: BikerData[i].BikerMobileNo,
                vehicleno: BikerData[i].VehicleNumber,
              })
            }
          } else {
            BikerData = []
            this.bikerlist = []
            this.$alertify.error(result.data.ReturnMessage)
          }

        }, error => {
          this.BikerNameLoading = ''
          console.error(error)
        })
    },
    selectBikerName(bikeritem) {
      this.bikeritem = bikeritem
      this.bikername = bikeritem.text
    },
    onSubmitLinehaulBikerTrip: function(bikertripTab) {
      this.$validator.validateAll('bikertripTab').then((result) => {
        if (!result) {
          return false;
        } else {
          this.GeneratePlacementID()
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    // Bug-7266: Showing all the Vehicle types while scheduling, for Local Vendor Based trip, even though only one type is mapped in TMS. 
    getVehicleTypeforMarket() {
       // Hub: 7244: VTRA
      if (this.triptypeitem.value =='local' && this.isVTRAFlag ){
        this.input = ({
          vendorid : this.localvendoritem.value,
          connectionId:this.connectionID
        });
      } else {
        this.input = ({})
      }
      this.vehicletypeloader = 'Loading Vehicle Type...'
      
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getVehicleTypeforMarketHired',
          params: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          let VehicleTypeDetails = result.data.ResponseData;
          for (var i = 0; i < VehicleTypeDetails.length; i++) {
            this.vehicletypelist.push({
              "value": VehicleTypeDetails[i].VehicleId,
              "text": VehicleTypeDetails[i].VehicleName
            })
          }
          this.vehicletypeloader = '';
        }, error => {
          this.vehicletypeloader = '';
          console.error(error)
        })
    },
    selectvehicletype(vehicletypeitem){
      this.vehicletype = vehicletypeitem.value
      this.vehicletypeitem = {
        value: '',
        text: ''
      }
      this.VehicleId = vehicletypeitem.value;
      this.VehicleName = vehicletypeitem.text;
      this.vehicletypeitem = vehicletypeitem;
       // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag){
        this.localvehiclenoitem = {
          value: '',
          text: '',
          isGPS: '',
          GPScompany: ''
        }
        this.localvehicleno = '',
        this.localvehiclenolist = [],
        this.VehicleError = '',
        this.getLocalVehicleNo()    
        this.getCutOffList()  
       }
    },

    ResetBikerTripDetails() {
      this.tripsheetno = ''
      var date = new Date()
      this.tripsheetnodate = moment(date).format('YYYY-MM-DD')
      this.routeitem = {
        value: '',
        text: '',
        actualroute: ''
      }
      this.route = ''
      this.RouteError = ''
      this.RouteLoading = ''
      this.actualroute = ''
      this.bikervehicleitem = {
        value: '',
        text: '',
        vehicleid: ''
      }
      this.bikervehiclenumber = ''
      this.BikerVehicleNumberLoading = ''
      this.bikeritem = {
          value: '',
          text: '',
          mobileno: '',
          vehicleno: ''
        },
        this.bikername = '',
        this.BikerNameLoading = '',
        this.openkm = ''
      this.$validator.reset()
      this.vehicletypelist = [],
      this.vehicletypeitem = {
        value: '',
        text: ''
      }
    },
  
     selectAdhocVendor(adhocvendoritem) {
      this.localvehiclenolist=[];
      this.localvehiclenoitem={};
      this.localvehicleno='';
      this.vehicletypelist = [],
      this.vehicletypeitem = {}
      this.vehicletype = ''

       if (!adhocvendoritem || !adhocvendoritem.value) {
        this.adhocvendoritem={}
        this.adhocvendor=''
        this.LocalVehicleNoLoading = ''
       return
      }
          this.adhocvendoritem = adhocvendoritem
      this.adhocvendor = adhocvendoritem.text
      console.log("this.adhocvendoritem.value",this.adhocvendoritem.value)
      this.getAdhocVehiclesMiddleMile(this.adhocvendoritem.value)
    },
   getAdhocVendorList(){
    this.LocalVendorLoading = 'Loading Vendor Name...'
    this.vehicletypelist = []
    this.input={
    "HubId":this.hubid[0],
    "ConnectionId":this.connectionID,
    "VendorType":"local"
    }
     axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'GetAdhocVendorDetails',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        }).then(result => {
          this.LocalVendorLoading = ''
          if (result.data.ResultCode == 100) 
            {
            this.adhocvendorlist = result.data.ResponseData.map(v => ({
            value: v.VehicleVendorId,
            text: v.VehicleVendorCompanyName
         }));
          }else{
            this.$alertify.error(result.data.ReturnMessage)
          }

           }) ,error => {
          this.LocalVendorLoading = ''
          console.error(error)
        }
  },
     adhocselectVehicleNo(option) {
  this.localvehicleno = option.text;    
  this.localvehiclenoitem = option;  
  this.vehicletypelist = [],
  this.vehicletypeitem = {
        value: option.raw.VehicleTypeId,
        text: option.raw.VehicleTypeName
      }
  this.vehicletypelist.push(this.vehicletypeitem)
  this.vehicletype=option.raw.VehicleTypeName
  // Update vendor to match the selected vehicle's vendor
  this.localvendoritem = {
    value: option.raw.VehicleVendorId,
    text: option.raw.VendorName
  };
  this.getVehicleDetails()
},
 getAdhocVehiclesMiddleMile(VehicleVendorId){
    this.LocalVehicleNoLoading = 'Loading Vehicle Number...'
    this.input={
    "HubId":this.hubid[0],
    "ConnectionId":this.connectionID,
    "VendorType":"local",
    "VehicleVendorId" :VehicleVendorId
    }
     axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'GetAdhocVehiclesMiddleMile',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        }).then(result => {
          this.LocalVehicleNoLoading = ''
          if (result.data.ResultCode == 100) 
            {
            this.localvehiclenolist = result.data.data.map(v => ({
               value: v.VehicleVendorId,
               text: v.VehicleNumber,
               raw: v 
            }));
          }
          else{
            this.$alertify.error(result.data.ReturnMessage)
          }
           }),error => {
          this.LocalVehicleNoLoading = ''
          console.error(error)
        }
  }
}
}



// WEBPACK FOOTER //
// ./src/views/components/NetworkManagement/ScheduledList/ScheduledList.js